import React, { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import { Layout } from "@/components/Layout";
import { ContentCard } from "@/components/ContentCard";
import api from "@/lib/api";
import { Search as SearchIcon } from "lucide-react";

export default function SearchPage() {
  const [params] = useSearchParams();
  const q = params.get("q") || "";
  const [items, setItems] = useState(null);

  useEffect(() => {
    if (!q) { setItems([]); return; }
    setItems(null);
    api.get("/content", { params: { search: q } }).then((r) => setItems(r.data)).catch(() => setItems([]));
  }, [q]);

  return (
    <Layout>
      <div className="pt-28 px-4 md:px-12 pb-12 min-h-[60vh]">
        <div className="flex items-center gap-2 text-slate-400">
          <SearchIcon size={20} />
          <span>Results for</span>
          <span className="text-white font-semibold">"{q}"</span>
        </div>
        {items === null ? (
          <div className="mt-8 grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-6 gap-4">
            {Array.from({ length: 6 }).map((_, i) => <div key={i} className="aspect-[2/3] rounded-lg skeleton" />)}
          </div>
        ) : items.length === 0 ? (
          <div className="text-slate-400 py-24 text-center">No titles matched your search.</div>
        ) : (
          <div className="mt-8 grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-6 gap-4 pb-8">
            {items.map((item) => (
              <div key={item.id} className="flex justify-center"><ContentCard item={item} /></div>
            ))}
          </div>
        )}
      </div>
    </Layout>
  );
}
